<template>
  <v-list
    v-bind="{ ...$attrs }"
    v-on="{ ...$listeners }"
    :style="listStyle"
  >
    <slot></slot>
  </v-list>
</template>

<script>
import { getTheme } from "@/plugins/vuetify"

export default {
  name: "ThemedList",
  props: {},
  computed: {
    listStyle() {
      return { backgroundColor: getTheme(this).bgCard }
    }
  }
}
</script>
